import type { Control } from "react-hook-form";
import { Checkbox } from "@/components/ui/checkbox";
import { FormControl, FormDescription, FormField, FormItem, FormLabel } from "@/components/ui/form";

/** Fields copied when applying a saved analysis profile. Privacy consent is deliberately excluded. */
export const PROFILE_TEMPLATE_FIELDS = [
  "companyName", "address", "phone", "email", "website", "vatNumber",
  "defaultLabourRate", "labourRateType", "defaultMarkupPercent", "defaultOverheadPercent",
  "quoteStyle", "region", "regionUplift", "quoteValidityDays", "brandColor", "logoUrl",
  "showCompanyName", "logoSize",
  "defaultTermsConditions", "defaultPaymentTerms",
] as const;

export function readPublicQuoteNameAllowed(profile: unknown): boolean {
  return (profile as { publicQuoteNameAllowed?: unknown } | null | undefined)?.publicQuoteNameAllowed === true;
}

export function PublicQuoteNameField({ control }: { control: Control<any> }) {
  return (
    <FormField
      control={control}
      name="publicQuoteNameAllowed"
      render={({ field }) => (
        <FormItem className="flex items-start gap-3 space-y-0 rounded-md border p-3">
          <FormControl>
            <Checkbox
              checked={field.value === true}
              onCheckedChange={(v) => field.onChange(v === true)}
              data-testid="checkbox-public-quote-name"
              className="mt-0.5"
            />
          </FormControl>
          <div className="space-y-1">
            <FormLabel>Allow my first name on public quote examples</FormLabel>
            <FormDescription>
              Optional. Shows only your first name, project type and generation time. Client names, addresses and prices are never shown. Leave off to keep all your examples, including past ones, anonymous.
            </FormDescription>
          </div>
        </FormItem>
      )}
    />
  );
}
